<template>
    <v-sheet>
        <template v-if="!multiple">       
            <template v-if="images?.length">
                <company-view-introduction-images-single v-bind="{ srcs }" />
            </template>
            <!-- <template v-if="!images?.length">
                <v-responsive :aspect-ratio="1200 / 675">
                    <v-overlay absolute light color="grey-f7">
                        <h3 class="tit tit--lg grey--text"> NO IMAGE </h3>
                    </v-overlay>
                </v-responsive>
            </template>
            <template v-else>
                <company-view-introduction-images-single v-bind="{ srcs }" />
            </template> -->
        </template>
        <template v-if="multiple">
            <company-view-introduction-images-multiple v-bind="{ srcs }" />
        </template>
    </v-sheet>
</template>

<script>
import CompanyViewIntroductionImagesMultiple from './company-view-introduction-images-multiple.vue';
import CompanyViewIntroductionImagesSingle from './company-view-introduction-images-single.vue';

export default {
    components: {
        CompanyViewIntroductionImagesMultiple,
        CompanyViewIntroductionImagesSingle,
    },
    props: {
        images: { type: Array, default: () => [] },
        multiple: { type: Boolean, default: false },
    },
    computed: {
        srcs() {
            return this.images.map(({ src }) => src);
        },
    },
};
</script>
